import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Player-hub Report tab: nudge when one more report is needed to stay in
 * the monthly strength statistics (Plan 050). Renders nothing otherwise.
 */
export default function ReportingBanner({ token }: { token: string }) {
  // Under the ['self-report', token] key so a submitted report refreshes it.
  const q = useQuery({
    queryKey: ['self-report', token, 'reporting'],
    queryFn: () => api.getSelfReportReporting(token),
    enabled: !!token,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  const own = q.data?.own;
  if (!own || own.status !== 'at_risk' || !own.reportByIso) return null;
  const by = new Date(own.reportByIso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
  return (
    <div className="rounded-lg border border-amber-800/70 bg-amber-950/30 px-4 py-3 text-sm">
      <div className="font-medium text-amber-100">Report your power before {by}</div>
      <div className="mt-0.5 text-xs text-amber-200/80">
        The monthly strength push only ranks players with a report within{' '}
        {q.data!.maxGapDays} days of the month's start and end. One update now keeps
        you in.
      </div>
    </div>
  );
}
